export const consiglioNazionaleMilano2025 = {
  id: 'static-consiglio-milano-2025',
  slug: 'consiglio-nazionale-milano-2025',
  title: 'Consiglio Nazionale Milano 2025',
  excerpt: 'Il Consiglio Nazionale UNASCA 2025 si è tenuto con grande successo a Milano il 25 maggio 2025 presso il prestigioso Quark Hotel.',
  body: `
    <h2>Consiglio Nazionale UNASCA - Milano 2025</h2>
    
    <p>Il <strong>25 maggio 2025</strong>, presso il prestigioso <strong>Quark Hotel di Milano</strong>, si è tenuto il Consiglio Nazionale UNASCA, un evento di grande rilevanza per il settore delle autoscuole e della formazione alla guida sicura.</p>
    
    <h3>Temi Principali</h3>
    
    <p>Durante l'incontro sono stati affrontati temi cruciali per il futuro del settore:</p>
    
    <ul>
      <li><strong>Innovazione nella formazione</strong> - Nuove metodologie didattiche e tecnologie per l'insegnamento</li>
      <li><strong>Normative europee</strong> - Adeguamento alle direttive UE sulla sicurezza stradale</li>
      <li><strong>Digitalizzazione</strong> - Implementazione di piattaforme digitali per esami e formazione</li>
      <li><strong>Sostenibilità</strong> - Promozione della mobilità sostenibile e veicoli elettrici</li>
    </ul>
    
    <h3>Partecipazione</h3>
    
    <p>L'evento ha visto la partecipazione di oltre <strong>150 rappresentanti</strong> delle autoscuole associate provenienti da tutta Italia, confermando l'importanza e l'interesse per le tematiche trattate.</p>
    
    <h3>Conclusioni</h3>
    
    <p>Il Consiglio Nazionale ha ribadito l'impegno di UNASCA nel supportare le autoscuole italiane attraverso:</p>
    
    <ul>
      <li>Formazione continua degli istruttori</li>
      <li>Supporto normativo e legale</li>
      <li>Innovazione tecnologica</li>
      <li>Rappresentanza istituzionale</li>
    </ul>
    
    <p>Un ringraziamento speciale a tutti i partecipanti che hanno contribuito al successo dell'evento.</p>
  `,
  featuredImage: '/images/milan-6391160_640.jpg',
  category: {
    id: 'eventi',
    name: 'Eventi',
    slug: 'eventi',
    color: '#8B5CF6'
  },
  tags: ['Consiglio Nazionale', 'Milano', 'Eventi', 'Formazione'],
  author: {
    id: 'unasca-admin',
    username: 'UNASCA',
    profile: {
      firstName: 'Segreteria',
      lastName: 'UNASCA',
      fullName: 'Segreteria UNASCA'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-05-26T10:00:00Z',
  createdAt: '2025-05-26T10:00:00Z',
  updatedAt: '2025-05-26T10:00:00Z',
  metadata: {
    views: 245,
    likeCount: 18,
    shares: 12
  },
  readingTime: 3
};

